export default __webpack_public_path__ + "static/media/fruit-icon.40b7abcd.svg";